/**
 * @generated SignedSource<<26c4275e4dd5cf3864111e980368b09b>>
 * @relayHash c447d7f12937b83f40ec059b5c894bfe
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c447d7f12937b83f40ec059b5c894bfe

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserInterfaceFlag = "COMPLETED_FIRST_TIME_PORTFOLIO_TEMPLATE_STORE_EXPERIENCE" | "DOCKED_SIDE_NAVIGATION" | "HIDE_APPBAR_SHARE_BUTTON_SPARKLE_ANIMATION" | "HIDE_BASIC_NETWORK_COLUMN_PREVIEWS" | "HIDE_C4C_AFTER_INVOICE_PAYMENT_PROMO_MODAL" | "HIDE_C4C_REFERRAL_BANNER" | "HIDE_C4C_REFERRAL_TOOLTIP" | "HIDE_CLIENT_COMPLETED_PAID_PROJECT_MODAL" | "HIDE_CLIENT_EDUCATION_COMPLIANT_CONTRACTS_BANNER" | "HIDE_CLIENT_EDUCATION_NETWORK_PAGE_BANNER" | "HIDE_CLIENT_EDUCATION_OPPORTUNITIES_PAGE_BANNER" | "HIDE_CLIENT_EDUCATION_PROJECTS_PAGE_BANNER" | "HIDE_CLIENT_EDUCATION_PROPOSAL_PAGE_BANNER" | "HIDE_CLIENT_FIRST_RECOMMENDATION_TOOLTIP" | "HIDE_CLIENT_HOME_PAGE_HIRE_BANNER" | "HIDE_CLIENT_MESSAGES_TOOLTIP" | "HIDE_CLIENT_OPPORTUNITIES_TOOLTIP" | "HIDE_CLIENT_PROJECTS_TOOLTIP" | "HIDE_CLIENT_SEARCH_PREVIEW_ENDED_MODAL" | "HIDE_CLIENT_SWITCH_MODAL" | "HIDE_CLIENT_WALLET_TOOLTIP" | "HIDE_CLIENT_WELCOME_TO_WORKSPACE_MODAL" | "HIDE_COMMUNITY_CHECKLIST_COMPLETED_SUCCESS_MESSAGE" | "HIDE_COMPLIANCE_OVERVIEW_BANNER" | "HIDE_CONTRACTOR_AND_CLIENT_ONBOARDING_TOUR" | "HIDE_CONTRACTOR_COMPLETED_PAID_PROJECT_MODAL" | "HIDE_CONTRACTOR_FIRST_LIVE_PROJECT_MODAL" | "HIDE_CONTRACTOR_FIRST_RECOMMENDATION_TOOLTIP" | "HIDE_CONTRACTOR_MESSAGES_TOOLTIP" | "HIDE_CONTRACTOR_OPPORTUNITIES_TOOLTIP" | "HIDE_CONTRACTOR_PROJECTS_TOOLTIP" | "HIDE_CONTRACTOR_REFERRAL_BANNER" | "HIDE_CONTRACTOR_SWITCH_MODAL" | "HIDE_CONTRACTOR_WALLET_TOOLTIP" | "HIDE_CONTRA_PRO_FLASH_SALE_BANNER" | "HIDE_CONTRA_PRO_GUIDE_ON_WAITLIST_COMPLETE_PROFILE_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_ON_WAITLIST_EXPLORE_PORTFOLIOS_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_ON_WAITLIST_SHARE_REFERRAL_LINK_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_SUBSCRIBED_WELCOME_TO_CONTRA_PRO_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_UPGRADE_NOW_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_WAITLIST_NOTIFICATION" | "HIDE_CONTRA_PRO_REDEEM_CODE_SUCCESS_BANNER" | "HIDE_CONTRA_PRO_SUBSCRIPTION_STICKY_FOOTER" | "HIDE_CREATOR_TOOLS_AWARD_BANNER" | "HIDE_CUSTOM_PORTFOLIO_EDIT_ON_CONTRA_MODAL" | "HIDE_DASHBOARD_PREVIEW_PORTFOLIO_CTA" | "HIDE_DASHBOARD_VIEW_PORTFOLIO_CTA" | "HIDE_DISCOVERABLE_ON_CONTRA_MODAL" | "HIDE_DISCOVERY_PROFILE_PREVIEW_CARD" | "HIDE_DISCOVER_EDUCATION_CLIENT_BANNER" | "HIDE_DISCOVER_EDUCATION_INDY_BANNER" | "HIDE_DISCOVER_INDY_COMMUNITY_SLACK_INVITE" | "HIDE_DISCOVER_SEARCH_PROFILE_COMPLETE_MODAL" | "HIDE_DISCOVER_SERVICES_INTRO_BANNER" | "HIDE_EDIT_FROM_PORTFOLIO_BANNER" | "HIDE_EXPLORE_CONTRA_PORTFOLIOS_CALLOUT" | "HIDE_FRAMER_AD_EXPERIMENT_ADVERTISEMENT" | "HIDE_FTUE_CLIENT_ACCEPTED_INQUIRY_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_COMPLIANT_CONTRACTS_INFORMATION" | "HIDE_FTUE_CLIENT_CREATED_INQUIRY_MODAL" | "HIDE_FTUE_CLIENT_CREATED_OPPORTUNITY_MODAL" | "HIDE_FTUE_CLIENT_DISCOVER_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_NETWORK_TABLE_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_NEW_JOB_MODAL" | "HIDE_FTUE_CLIENT_OPPORTUNITIES_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_PROJECTS_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_DISCOVER_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_INVITED_TO_COMPANY_MODAL" | "HIDE_FTUE_CONTRACTOR_OPPORTUNITIES_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_PROFILE_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_PROJECTS_GUIDED_TOUR" | "HIDE_FTUE_CONTRA_PROFILE_MAGIC" | "HIDE_FTUE_CONTRA_PROFILE_MAGIC_REVEAL_ANIMATION" | "HIDE_FTUE_CREATED_ITPP_MODAL" | "HIDE_FTUE_CUSTOM_PORTFOLIOS_MODAL" | "HIDE_FTUE_CWA_CUSTOM_PORTFOLIOS_MODAL" | "HIDE_FTUE_DASHBOARD_NEW_ANALYTICS_BANNER" | "HIDE_FTUE_DASHBOARD_NEW_ANALYTICS_MODAL" | "HIDE_FTUE_DASHBOARD_ONBOARDING_EDUCATION_MODAL" | "HIDE_FTUE_DISCOVER_JOBS_COMMUNITY_GUIDELINES_MODAL" | "HIDE_FTUE_INVITE_AND_EARN_MODAL" | "HIDE_FTUE_IP_INCOMPLETE_PREVIEW_MODAL" | "HIDE_FTUE_NEW_INDY_DASHBOARD_WELCOME_MODAL" | "HIDE_FTUE_ONBOARDING_COMPLETED_MODAL" | "HIDE_FTUE_PORTFOLIOS_CUSTOM_DOMAIN_CALLOUT" | "HIDE_FTUE_PORTFOLIOS_TOOLTIP_GUIDE" | "HIDE_FTUE_PORTFOLIOS_UPGRADE_TO_CUSTOMIZE_SIDEBAR_CALLOUT" | "HIDE_FTUE_PROFILE_EXPLORE_PORTFOLIOS_CALLOUT" | "HIDE_FTUE_PROJECTS_PAGE_BRAND_CUSTOMIZATION_CALLOUT" | "HIDE_FTUE_UNLOCK_INDY_JOURNEY_MODAL" | "HIDE_FUTURE_IS_FLEXIBLE_CLIENT_SURVEY_BANNER" | "HIDE_HIRING_EXPERIENCE_EDUCATION_MODAL" | "HIDE_ITPP_ANNOUNCEMENT_BANNER" | "HIDE_ITPP_TOOLTIP" | "HIDE_MESSAGES_UNLOCK_MODAL" | "HIDE_NEW_FEATURES_UNLOCKED_EXPERIENCE" | "HIDE_NEW_OPPORTUNITIES_PAGE_BANNER" | "HIDE_NEW_PROJECTS_PAGE_BANNER" | "HIDE_ONBOARDING_REMINDER_MODAL" | "HIDE_PORTFOLIO_PROJECT_MAGIC_SUGGESTION_TOOLTIP" | "HIDE_PRIMARY_ROLE_CHANGED_WARNING_MODAL" | "HIDE_PRODUCT_HUNT_BANNER" | "HIDE_PRODUCT_HUNT_BANNER_C4C" | "HIDE_PROJECT_GUIDE_CARD" | "HIDE_REFERRAL_BANNER_ON_INVOICE" | "HIDE_REFERRAL_BANNER_ON_PAID_PROJECT" | "HIDE_REFERRAL_BANNER_ON_REQUEST_RECOMMENDATION" | "HIDE_VISUAL_ELECTRIC_ADS_ADVERTISEMENT" | "HIDE_WELCOME_TO_CONTRA_PRO_GUIDE_CHECKLIST_CARD" | "HIDE_WIX_STUDIO_ADS_ADVERTISEMENT" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_BOOST_PORTFOLIO_VISIBILITY_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_CONNECT_CUSTOM_DOMAIN_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_PUBLISH_YOUR_PORTFOLIO_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_SHARE_LINK_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_ON_WAITLIST_COMPLETE_PROFILE_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_ON_WAITLIST_EXPLORE_PORTFOLIOS_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_ON_WAITLIST_SHARE_REFERRAL_LINK_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_SUBSCRIBED_WELCOME_TO_CONTRA_PRO_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_UPGRADE_NOW_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_WAITLIST_NOTIFICATION" | "SEEN_CONTRA_PRO_SUBSCRIPTION_MODAL" | "SEEN_FEED_FTUE_MODAL" | "SEEN_JOB_VISIBILITY_MODAL" | "SEEN_PROFILE_MAGIC_MODAL" | "SEEN_WELCOME_TO_YOUR_COMPANY_PROFILE_MODAL" | "STOP_SHOWING_ONBOARDING_CHECKLIST" | "%future added value";
export type useProfileMagicPollingQuery$variables = {
  skip: boolean;
};
export type useProfileMagicPollingQuery$data = {
  readonly visitor?: {
    readonly userAccount: {
      readonly contraMagicBioSuggestions: ReadonlyArray<{
        readonly id: string;
        readonly isSelected: boolean;
        readonly requestId: string;
        readonly suggestion: string;
      }> | null;
      readonly contraMagicOneLinerSuggestions: ReadonlyArray<{
        readonly id: string;
        readonly isSelected: boolean;
        readonly requestId: string;
        readonly suggestion: string;
      }> | null;
      readonly contraMagicQuestionnaireResponse: {
        readonly whatMakesYouUnique: string;
        readonly whatServicesDoYouOffer: string;
      } | null;
      readonly profile: {
        readonly bio: string | null;
        readonly portfolioProjects: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly author: {
                readonly id: string;
              } | null;
              readonly id: string;
              readonly llmSuggestionId: string | null;
              readonly " $fragmentSpreads": FragmentRefs<"ProjectCardV2DataWrapper_portfolioProject">;
            };
          }>;
        };
        readonly productizedServices: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly llmSuggestionId: string | null;
              readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardDataWrapper">;
            };
          }>;
        };
        readonly title: string | null;
      };
      readonly userInterfaceFlags: ReadonlyArray<UserInterfaceFlag>;
      readonly " $fragmentSpreads": FragmentRefs<"OpenProfileCompletionChecklistButton_userAccount">;
    } | null;
  };
};
export type useProfileMagicPollingQuery = {
  response: useProfileMagicPollingQuery$data;
  variables: useProfileMagicPollingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraMagicQuestionnaireResponse",
  "kind": "LinkedField",
  "name": "contraMagicQuestionnaireResponse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whatMakesYouUnique",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whatServicesDoYouOffer",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSelected",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "suggestion",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requestId",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraMagicSuggestion",
  "kind": "LinkedField",
  "name": "contraMagicBioSuggestions",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraMagicSuggestion",
  "kind": "LinkedField",
  "name": "contraMagicOneLinerSuggestions",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bio",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "ALL"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "llmSuggestionId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userInterfaceFlags",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "style",
      "storageKey": null
    }
  ],
  "type": "PortfolioProjectTextCover",
  "abstractKey": null
},
v18 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Role",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v18/*: any*/),
    "storageKey": null
  }
],
v20 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Tool",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v18/*: any*/),
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v22 = [
  (v21/*: any*/)
],
v23 = [
  (v21/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requiredCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useProfileMagicPollingQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Visitor",
            "kind": "LinkedField",
            "name": "visitor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAccount",
                "kind": "LinkedField",
                "name": "userAccount",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "concreteType": "UserProfilePortfolioProjectConnection",
                        "kind": "LinkedField",
                        "name": "portfolioProjects",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfilePortfolioProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PortfolioProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "ProjectCardV2DataWrapper_portfolioProject"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "portfolioProjects(type:\"ALL\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfileProductizedServiceConnection",
                        "kind": "LinkedField",
                        "name": "productizedServices",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfileProductizedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductizedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "ProductizedServiceCardDataWrapper"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OpenProfileCompletionChecklistButton_userAccount"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useProfileMagicPollingQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Visitor",
            "kind": "LinkedField",
            "name": "visitor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAccount",
                "kind": "LinkedField",
                "name": "userAccount",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "concreteType": "UserProfilePortfolioProjectConnection",
                        "kind": "LinkedField",
                        "name": "portfolioProjects",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfilePortfolioProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PortfolioProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "cover",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContraImage",
                                            "kind": "LinkedField",
                                            "name": "image",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "animated",
                                                "storageKey": null
                                              },
                                              (v16/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PortfolioProjectImageCover",
                                        "abstractKey": null
                                      },
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PortfolioProjectRoleConnection",
                                    "kind": "LinkedField",
                                    "name": "roles",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PortfolioProjectRoleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": (v19/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PortfolioProjectToolConnection",
                                    "kind": "LinkedField",
                                    "name": "tools",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PortfolioProjectToolEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": (v20/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "portfolioProjects(type:\"ALL\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfileProductizedServiceConnection",
                        "kind": "LinkedField",
                        "name": "productizedServices",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfileProductizedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductizedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v9/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductizedServicePrice",
                                    "kind": "LinkedField",
                                    "name": "price",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "amount",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "interval",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "timeline",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserProfile",
                                    "kind": "LinkedField",
                                    "name": "userProfile",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "visitorCanEdit",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductizedServiceRoleConnection",
                                    "kind": "LinkedField",
                                    "name": "roles",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductizedServiceRoleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": (v19/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductizedServiceToolConnection",
                                    "kind": "LinkedField",
                                    "name": "tools",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductizedServiceToolEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": (v20/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductizedServicePortfolioProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "portfolioProjects",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductizedServicePortfolioProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PortfolioProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v7/*: any*/),
                                              (v13/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "cover",
                                                "plural": false,
                                                "selections": [
                                                  (v15/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "ContraImage",
                                                        "kind": "LinkedField",
                                                        "name": "image",
                                                        "plural": false,
                                                        "selections": [
                                                          (v16/*: any*/),
                                                          (v2/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "PortfolioProjectImageCover",
                                                    "abstractKey": null
                                                  },
                                                  (v17/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayUsername",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfileRoleConnection",
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserAccountRoleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "skillName",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActionChecklist",
                    "kind": "LinkedField",
                    "name": "contractorProfileCompletionChecklist",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "percentComplete",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "ContractorOnboardingUserActionChecklistItem",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "BioUserActionChecklistItem",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "TitleUserActionChecklistItem",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "PortfolioProjectUserActionChecklistItem",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v23/*: any*/),
                            "type": "ProductizedServiceUserActionChecklistItem",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "WalletUserActionChecklistItem",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userGroups",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c447d7f12937b83f40ec059b5c894bfe",
    "metadata": {},
    "name": "useProfileMagicPollingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "69c6dbdd468cf281bc203201841ae1c0";

export default node;
